import { sortByIndex } from '../utils/node';
import { getCacheByType } from './raster';

export function prepareLayerCache(renderContext) {
  const cache = getCacheByType(renderContext, 'layersHash');
  const layerCache = {};
  const allNodes = renderContext.api.getNodes();
  const sortedNodes = allNodes.slice().sort(sortByIndex);
  const indexMap = new Map();
  for (let i = 0; i < sortedNodes.length; i++) {
    indexMap.set(sortedNodes[i].id, i);
  }
  layerCache.zOrder = { sortedNodes, indexMap };
  cache.set('layers', layerCache);
  return layerCache;
}

export function getBackNodesHash(renderContext, node) {
  const box = renderContext.api.getNodeBox(node);
  const { scale: scaleProvider, dirty: dirtyProvider } = renderContext.providers;
  const scaleValue = scaleProvider.scale;

  // Cache z-order (sorted nodes + index map) to avoid per-call sorting
  const cache = getCacheByType(renderContext, 'layersHash');
  let layerCache = cache.get('layers');
  if (!layerCache) {
    layerCache = prepareLayerCache(renderContext);
  }

  const { sortedNodes, indexMap } = layerCache.zOrder;
  const currentNodeIndex = indexMap.get(node.id);

  // Build a compact signature of back nodes that visually affect the box
  const parts = [];
  const maxIndex = typeof currentNodeIndex === 'number' ? currentNodeIndex : 0;
  if (maxIndex > 0 && box) {
    for (let i = 0; i < maxIndex; i++) {
      const n = sortedNodes[i];
      if (n.visible === false) continue;
      if (n.opacity !== undefined && n.opacity <= 0) continue;
      const nbox = renderContext.api.getNodeBox(n);
      if (!nbox || !nbox.intersection(box)) continue;
      parts.push(n.id, dirtyProvider.getVersion(n.id), n._img?.loading ? 1 : 0);
    }
  }

  const backNodesHash = parts.join('_');
  const bx = box?.x || 0,
    by = box?.y || 0,
    bw = box?.w || 0,
    bh = box?.h || 0;
  const nodeVersion = dirtyProvider.getVersion(node.id);
  const cacheKey = `${bx}_${by}_${bw}_${bh}_${nodeVersion}_${Math.round(scaleValue)}_${backNodesHash}`;
  return cacheKey;
}
